import createHistory from 'history/createBrowserHistory';

import './checkout/style/style.css';
import App from './checkout/components/app';

const getProps = () => {
  const history = createHistory();
  return { history };
};
const props = getProps();
const Entry = () => <App {...props} />;

export default Entry;



// WEBPACK FOOTER //
// ./index.checkout.js